var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBookmarkCheck = function SvgBookmarkCheck(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none",
    viewBox: "0 0 27 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "m12.738 12.876-1.161-1.16a.53.53 0 0 0-.383-.153.52.52 0 0 0-.384.159.52.52 0 0 0-.158.383q0 .225.159.383l1.287 1.294a.86.86 0 0 0 .626.263.86.86 0 0 0 .626-.263l3.59-3.596a.55.55 0 0 0 .168-.373.5.5 0 0 0-.169-.393.52.52 0 0 0-.383-.159.52.52 0 0 0-.383.159zm1.137 5.456-4.05 1.742q-.875.377-1.662-.145-.788-.522-.788-1.457V6.082q0-.748.501-1.249.5-.501 1.25-.501h9.499q.748 0 1.249.501.501.5.501 1.25v12.389q0 .935-.788 1.457-.787.522-1.662.145z"
  })));
};
export default SvgBookmarkCheck;